<template>
<div v-if="config != null">
    <!-- Tabs with card integration -->
    <b-form @submit.prevent="reRender()">
        <!-- <pre>index: {{this.config}} </pre> -->
        <b-card no-body>
            <b-tabs pills v-model="tabIndex" small card>
                <b-tab title="System">
                    <system :config="config" :changed="changed" :changes="changes"></system>
                </b-tab>
                <b-tab title="WAN">
                    <wan :config="config" :changed="changed" :changes="changes"></wan>
                </b-tab>
                <b-tab title="LAN">
                    <lan :config="config" :changed="changed" :changes="changes"></lan>
                </b-tab>
                <b-tab title="Wireless">
                    <wifi :config="config" :changed="changed" :changes="changes"></wifi>
                </b-tab>

                <b-tab title="LTE" v-if="config.snippet.profile.default != 0">
                    <lte :config="config" :changed="changed" :changes="changes"></lte>
                </b-tab>

            </b-tabs>
        </b-card>
    </b-form>
</div>
<div v-else>
    No data for this config
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import WAN from "@/readynet/configs/network/Wan";
import LAN from "@/readynet/configs/network/Lan";
import Wifi from "@/readynet/configs/network/Wireless";
import System from "@/readynet/configs/network/System";
import LTE from "@/readynet/configs/network/LTE";

export default {
    components: {
        Multiselect,
        'wan': WAN,
        'lan': LAN,
        'wifi': Wifi,
        'system': System,
        'lte': LTE,
    },
    props: {
        config: {},
        changed: {
            type: Array,

        },
        changes: {
            type: Object,

        },
    },

    data() {
        return {
            tabIndex: 0,
            loading: false,
        }
    },

    mounted() {
        // console.log(this.params)
    },
    methods: {
        reRender() {
            this.$forceUpdate()
        }
    },

    onSubmit() {},

}
</script>
